import { render, staticRenderFns } from "./profile-edit.vue?vue&type=template&id=07aca8a4&scoped=true&"
import script from "./profile-edit.vue?vue&type=script&lang=js&"
export * from "./profile-edit.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit.vue?vue&type=style&index=0&id=07aca8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aca8a4",
  null
  
)

export default component.exports